import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import classnames from 'classnames';
import { setCookie } from 'bv';

import TabView from './tab_view';
import useFeature from '../../hooks/use_feature';

// Rules for a tab to be active
// if url is / or /sports -> active when sports or children, or exact with /
// Others do not need to be exact
const sportsRules = ['/sports', { path: '/', exact: true }];

const rules = (url) => ({
  '/': sportsRules,
  '/sports': sportsRules,
}[url] || [url]);

const onTabClicked = (dimensionId) => () => {
  setCookie('product_id', dimensionId);
};

const TabContainer = ({
  label,
  url,
  className,
  dimensionId,
  feature,
  ...rest
}) => {
  const selected = rules(url).some((rule) => useRouteMatch(rule));

  if (feature) {
    const [featureEnabled] = useFeature(feature);

    if (!featureEnabled) return null;
  }

  return (
    <TabView
      label={label}
      className={classnames('section', className, { selected })}
      url={url}
      onClick={onTabClicked(dimensionId, url)}
      {...rest}
    />
  );
};

TabContainer.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dimensionId: PropTypes.number.isRequired,
  feature: PropTypes.string.isRequired,
};

export default TabContainer;
